<template>
  <!-- -->
  <div class="schoolTeacher" v-if="columns.length > 0 && authority">
    <div style="width: 100% ,overflowY: auto">
      <van-tabs v-model="active1" color="#1989fa" :ellipsis="false" @click="test">
        <van-tab v-if="columns.length > 1">
          <div class="tab-title" slot="title" @click="test(columns, 'total')">
            全部
          </div>
        </van-tab>
        <van-tab
          :title="item.text || item.deptName"
          :name="item.id"
          v-for="item in columns"
          :key="item.id"
        >
          <van-tabs
            color="#1989fa"
            :ellipsis="false"
            @click="test"
            v-model="active2"
            v-if="item.children && item.children.length > 0"
          >
            <van-tab v-if="item.children.length > 1">
              <div
                class="tab-title"
                slot="title"
                @click="test(item, 'total')"
              >
                全部
              </div>
            </van-tab>
            <van-tab
              :title="item1.text|| item.deptName"
              :name="item1.id"
              v-for="item1 in item.children"
              :key="item1.id"
            >
              <van-tabs
                color="#1989fa"
                :ellipsis="false"
                @click="test"
                v-model="active3"
                v-if="item1.children && item1.children.length > 0"
              >
                <van-tab v-if="item1.children.length > 1">
                  <div
                    class="tab-title"
                    slot="title"
                    @click="test(item1, 'total')"
                  >
                    全部
                  </div>
                </van-tab>
                <van-tab
                  :title="item2.text || item.deptName"
                  :name="item2.id"
                  v-for="item2 in item1.children"
                  :key="item2.id"
                >
                  <van-tabs
                    color="#1989fa"
                    :ellipsis="false"
                    @click="test"
                    v-model="active4"
                    v-if="item2.children && item2.children.length > 0"
                  >
                    <van-tab v-if="item2.children.length > 1">
                      <div
                        class="tab-title"
                        slot="title"
                        @click="test(item2, 'total')"
                      >
                        全部
                      </div>
                    </van-tab>
                    <van-tab
                      :title="item3.text || item.deptName"
                      :name="item3.id"
                      v-for="item3 in item2.children"
                      :key="item3.id"
                    >
                      <van-tabs
                        color="#1989fa"
                        @click="test"
                        :ellipsis="false"
                        v-model="active5"
                        v-if="item3.children && item3.children.length > 0"
                      >
                        <van-tab v-if="item3.children.length > 1">
                          <div
                            class="tab-title"
                            slot="title"
                            @click="test(item3, 'total')"
                          >
                            全部
                          </div>
                        </van-tab>
                        <van-tab
                          :title="item4.text || item.deptName"
                          :name="item4.id"
                          v-for="item4 in item3.children"
                          :key="item4.id"
                        >
                          <van-tabs
                            color="#1989fa"
                            :ellipsis="false"
                            v-model="active6"
                            v-if="item4.children && item4.children.length > 0"
                          >
                            <van-tab v-if="item4.children.length > 1">
                              <div
                                class="tab-title"
                                slot="title"
                                @click="test(item4, 'total')"
                              >
                                全部
                              </div></van-tab
                            >
                            <van-tab
                              :title="item5.text || item.deptName"
                              :name="item5.id"
                              v-for="item5 in item4.children"
                              :key="item5.id"
                            >
                              <van-tabs
                                color="#1989fa"
                                :ellipsis="false"
                                v-model="active7"
                                v-if="
                                  item5.children && item5.children.length > 0
                                "
                              >
                                <van-tab v-if="item5.children.length > 1">
                                  <div
                                    class="tab-title"
                                    slot="title"
                                    @click="test(item5, 'total')"
                                  >
                                    全部
                                  </div>
                                </van-tab>
                                <van-tab
                                  :title="item6.text || item.deptName"
                                  :name="item6.id"
                                  v-for="item6 in item5.children"
                                  :key="item6.id"
                                >
                                  <van-tabs
                                    color="#1989fa"
                                    :ellipsis="false"
                                    v-model="active8"
                                    v-if="
                                      item6.children &&
                                      item6.children.length > 0
                                    "
                                  >
                                    <van-tab v-if="item6.children.length > 1">
                                      <div
                                        class="tab-title"
                                        slot="title"
                                        @click="test(item6, 'total')"
                                      >
                                        全部
                                      </div>
                                    </van-tab>
                                    <van-tab
                                      :title="item7.text || item.deptName"
                                      :name="item7.id"
                                      v-for="item7 in item6.children"
                                      :key="item7.id"
                                    >
                                      <van-tabs
                                        color="#1989fa"
                                        :ellipsis="false"
                                        v-model="active9"
                                        v-if="
                                          item7.children &&
                                          item7.children.length > 0
                                        "
                                      >
                                        <van-tab
                                          v-if="item7.children.length > 1"
                                        >
                                          <div
                                            class="tab-title"
                                            slot="title"
                                            @click="
                                              test(item7, 'total')
                                            "
                                          >
                                            全部
                                          </div>
                                        </van-tab>
                                        <van-tab
                                          :name="item8.id"
                                          :title="item8.text || item.deptName"
                                          v-for="item8 in item7.children"
                                          :key="item8.id"
                                        >
                                          <van-tabs
                                            color="#1989fa"
                                            :ellipsis="false"
                                            v-model="active10"
                                            v-if="
                                              item8.children &&
                                              item8.children.length > 0
                                            "
                                          >
                                            <van-tab
                                              v-if="item8.children.length > 1"
                                            >
                                              <div
                                                class="tab-title"
                                                slot="title"
                                                @click="
                                                  test(item8, 'total')
                                                "
                                              >
                                                全部
                                              </div>
                                            </van-tab>
                                            <van-tab
                                              :title="item9.text || item.deptName"
                                              :name="item9.id"
                                              v-for="item9 in item8.children"
                                              :key="item9.id"
                                            >
                                              <van-tabs
                                                color="#1989fa"
                                                :ellipsis="false"
                                                v-model="active11"
                                                v-if="
                                                  item9.children &&
                                                  item9.children.length > 0
                                                "
                                              >
                                                <van-tab
                                                  title="全部"
                                                  v-if="
                                                    item9.children.length > 1
                                                  "
                                                >
                                                  <div
                                                    class="tab-title"
                                                    slot="title"
                                                    @click="
                                                      test(
                                                        item9,
                                                        'total'
                                                      )
                                                    "
                                                  >
                                                    全部
                                                  </div>
                                                </van-tab>
                                                <van-tab
                                                  :title="item10.text || item.deptName"
                                                  :name="item10.id"
                                                  v-for="item10 in item9.children"
                                                  :key="item10.id"
                                                >
                                                </van-tab>
                                              </van-tabs>
                                            </van-tab>
                                          </van-tabs>
                                        </van-tab>
                                      </van-tabs>
                                    </van-tab>
                                  </van-tabs>
                                </van-tab>
                              </van-tabs>
                            </van-tab>
                          </van-tabs>
                        </van-tab>
                      </van-tabs>
                    </van-tab>
                  </van-tabs>
                </van-tab>
              </van-tabs>
            </van-tab>
          </van-tabs>
        </van-tab>
      </van-tabs>
    </div>

    <div class="wrap">
      <div class="wrap-1">
        <div class="class-date flex flex-center">
          <van-icon name="arrow-left" @click="prevArrow" />
          <span @click="selectDate">{{ date }}</span>
          <van-icon name="arrow" @click="nextArrow" />
        </div>
        <div class="ss-info" ref="scroll">
          <div class="ss-info-content">
            <div
              :class="['info-item', { acitve: infoItemClass == 1 }]"
              @click="selectInfoItem(1, 'studentClocksDTOList')"
            >
              <div class="info-count">
                <span>{{ data.classNumber || 0 }}</span>
                <span class="unit">人</span>
              </div>
              <div class="info-name">应到</div>
            </div>
            <div
              :class="['info-item', { acitve: infoItemClass == 2 }]"
              @click="selectInfoItem(2, 'normalStudentClocksDTOList')"
            >
              <div class="info-count">
                <span>{{ data.normalNumber || 0 }}</span>
                <span class="unit">人</span>
              </div>
              <div class="info-name">实到</div>
            </div>
            <div
              :class="['info-item', { acitve: infoItemClass == 3 }]"
              @click="selectInfoItem(3, 'absenceStudentClocksDTOList')"
            >
              <div class="info-count">
                <span style="color: #d21111">{{
                  data.absenceNumber || 0
                }}</span>
                <span class="unit">人</span>
              </div>
              <div class="info-name">缺勤</div>
            </div>
            <div
              :class="['info-item', { acitve: infoItemClass == 4 }]"
              @click="selectInfoItem(4, 'leaveStudentClocksDTOList')"
            >
              <div class="info-count">
                <span>{{ data.leaveNumber || 0 }}</span>
                <span class="unit">人</span>
              </div>
              <div class="info-name">请假</div>
            </div>
            <div
              :class="['info-item', { acitve: infoItemClass == 5 }]"
              @click="selectInfoItem(5, 'lateStudentClocksDTOList')"
            >
              <div class="info-count">
                <span>{{ data.lateNumber || 0 }}</span>
                <span class="unit">人</span>
              </div>
              <div class="info-name">迟到</div>
            </div>
            <div
              :class="['info-item', { acitve: infoItemClass == 6 }]"
              @click="selectInfoItem(6, 'earlyStudentClocksDTOList')"
            >
              <div class="info-count">
                <span>{{ data.earlyNumber || 0 }}</span>
                <span class="unit">人</span>
              </div>
              <div class="info-name">早退</div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap-1">
        <div class="title flex flex-b flex-vc">
          <span>出勤详情</span>
        </div>
        <div class="list-table">
          <div class="list-table-thead">
            <div class="table-1 flex-1">姓名</div>
            <div class="table-3 flex-2">
              <div class="top">上午</div>
              <div class="flex status"><span>到校</span><span>离校</span></div>
            </div>
            <div class="table-3 flex-2">
              <div class="top">下午</div>
              <div class="flex status"><span>到校</span><span>离校</span></div>
            </div>
          </div>
          <div
            class="list-table-body"
            v-if="data && data[dataKey] && data[dataKey].length > 0"
          >
            <div
              class="flex list-table-item"
              v-for="(item, index) in data && data[dataKey]"
              :key="index"
            >
              <div class="table-1 flex-1">
                <!-- <span class="mark blue" :class="getCheckState(item)"></span> -->
                <span>{{ item.userName }}</span>
              </div>
              <div class="table-3 flex-2 flex">
                <span class="flex-1">{{ item.amFirstClockTime }}</span>
                <span class="flex-1">{{ item.amLastClockTime }}</span>
              </div>
              <div class="table-3 flex-2 flex">
                <span class="flex-1">{{ item.pmFirstClockTime }}</span>
                <span class="flex-1">{{ item.pmLastClockTime }}</span>
              </div>
            </div>
          </div>
          <van-empty
            v-show="
              loading &&
              (!data ||
                (data && !data[dataKey]) ||
                (data && data[dataKey] && data[dataKey].length < 1))
            "
            description="暂无人员"
          />
        </div>
      </div>
    </div>

    <SelectTime
      ref="starttime"
      :typeTime="'选择开始时间'"
      @time="handleTimeStartConfirm"
      :minDate="minDate"
      :maxDate="new Date()"
      type="date"
      :currentDate="startMinTime"
    />
  </div>
  <van-empty v-else description="暂无权限，您不是该部门的负责人，联系学校管理员将您设置为负责人后方可查看" />
</template>

<script>
import SelectTime from "@/components/subScribePopup/selectTime";
import moment from "moment";
import BScroll from "@better-scroll/core";
export default {
  data() {
    return {
      classId: "",
      data: {},
      columns: [],
      date: moment().format("YYYY-MM-DD"),
      startMinTime: new Date(moment().format("YYYY-MM-DD")),
      minDate: new Date(2020, 1, 1),
      dataKey: "studentClocksDTOList",
      infoItemClass: 1,
      loading: false,
      authority: false,
      // 部门选择弹窗展示
      showPicker: false,


       // 标标签页默认值
      active1: '',
      active2: '',
      active3: '',
      active4: '',
      active5: '',
      active6: '',
      active7: '',
      active8: '',
      active9: '',
      active10: '',
      active11: ''
    };
  },
  mounted() {
    this.initScroll();
    this.getTab();
    // this.getClassListByTeacherId()
  },

  methods: {
    initScroll() {
      this.bs = new BScroll(this.$refs.scroll, {
        scrollX: true,
        click: true,
        probeType: 3, // listening scroll hook
      });
    },
    handleChangeTab(id) {
      this.classId = id;
      this.getStudentDataByDeptIdAndDate();
    },

    // tab栏选中获取出勤详情
    test(a, b) {
      console.log("a,b", a, b);
      if (a == 0 && !b) {
        return;
      }

      // 点击根节点
      if (b == "total" && Array.isArray(a)) {
        // 获取所有的部门
        let arr = [];

        console.log("获取待处理的数据", a);
        let fn = (data) => {
          data.forEach((item) => {
            arr.push(item.id);
            if (item.children && item.children.length) {
              fn(item.children);
            } else {
              return;
            }
          });
        };

        fn(a);

        this.classId = arr;
        this.getStudentDataByDeptIdAndDate();
      } else if (b == "total" && !Array.isArray(a) && a instanceof Object) { // 点击次根节点
        // 获取所有的部门
        let arr = [];

        console.log("获取待处理的数据", a);
        let fn = (data) => {
          data.forEach((item) => {
            arr.push(item.id);
            if (item.children && item.children.length) {
              fn(item.children);
            } else {
              return;
            }
          });
        };
        arr.push(a.id)
        fn(a.children);

        this.classId = arr;
        this.getStudentDataByDeptIdAndDate();
      } else { // 点击子节点
        let arr = [];
        let classId;

        let fn2 = (data) => {
          data.forEach((item, index) => {
            if (item.children && item.children.length) {
              arr.push(item.id);
              fn2(item.children);
            } else {
              arr.push(item.id);
            }
          });
        };

        let fn = (data) => {
          data.forEach((item) => {
            if (item.id == a) {
              if (item.children && item.children.length) {
                arr.push(item.id);
                fn2(item.children);
              } else {
                console.log("item下没有子节点", item);
                return (classId = item.id);
              }
            } else {
              if (item.children && item.children.length) {
                fn(item.children);
              }
            }
          });
        };

        fn(this.columns);

        this.classId = classId || arr;
        this.getStudentDataByDeptIdAndDate();
      }
    },

    selectDate() {
      this.$refs.starttime.showTimePopup = true;
    },
    selectInfoItem(index, key) {
      this.infoItemClass = index;
      this.dataKey = key;
    },
    handleTimeStartConfirm(v) {
      this.date = v;
      this.getStudentDataByDeptIdAndDate();
    },

    async getTab() {
      const { code, data } =
        await this.$https.getDeptStaticsDataByteacherIdAndDate({
          // schoolId: this.$store.state.schoolId,
          teacherId: this.$store.state.userId,
        });

      if (code !== 200) {
        return;
      }

      this.setDeptData(data);

      let zhi;
      let fn = (data) => {
        data.forEach((item) => {
          if (item.id == this.$route.query.id) {
            zhi = item;
          } else {
            if (item.children && item.children.length) {
              fn(item.children);
            }
          }
        });
      };
      if (data && data.length) {
        fn(data);
      }

      console.log(zhi);
      this.classId = this.$route.query.id;
      this.findPersonList() 
      if (
        (zhi && data && data.length > 0) ||
        (this.$route.query.id == 0 && data && data.length > 0)
      ) {
        this.authority = true;
        this.getStudentDataByDeptIdAndDate();
      }
    },
    findPersonList () {
      let arr = []
      function fn (data,target,result) {
        for (let i in data) {
          let item = data[i]
          if (item.id == target) {
            result.unshift(item.id)
            return true
          }
          if (item.children && item.children.length > 0) {
            let ok = fn(item.children,target,result)
            if (ok) {
              result.unshift(item.id)
              return true
            }
          }
        }
        return false

      }
      fn(this.columns,this.classId,arr)

      
      for(let i = 0 ; i < arr.length ; i++) {
        this[`active${i + 1}`] = arr[i]
      }
    },

    // 组装部门数据
    setDeptData(data) {
      function fn(data) {
        data.forEach((item,index) => {
          console.log("item", item);
          if (item.deptName && item.deptName == '全部') {
            data.splice(index,1)
          } else {
            item.text = item.label;
            item.name = item.id;
          }
         
          if (item.children && item.children.length) {
            fn(item.children);
          } else {
            return;
          }
        });
      }
      fn(data);
      this.columns = data;
    },

    onConfirm(value, index) {
      let length = value.filter((item) => item != "").length;
      index.length = length;
      let obj = this.columns;
      for (let i = 0; i < index.length; i++) {
        if (i > 0) {
          obj = obj.children[index[i]];
        } else {
          obj = obj[index[i]];
        }
      }
      this.classId = obj.id;
      console.log("value", value);
      this.deptChangeName = value.filter((item) => item != "")[
        value.filter((item) => item != "").length - 1
      ];
      this.showPicker = false;
      this.getStudentDataByDeptIdAndDate();
    },

    async getStudentDataByDeptIdAndDate() {
      let zhiClass = [];

      if (this.classId && !Array.isArray(this.classId) && this.classId > 0) {
        console.log("this.classId", this.classId);
        zhiClass[0] = this.classId;
      } else if (Array.isArray(this.classId) && this.classId.length > 0) {
        zhiClass = this.classId;
      } else {
        // 获取全部部门id
        console.log("获取全部部门id", this.columns);

        let getIds = function (data) {
          data.forEach((item) => {
            zhiClass.push(item.id);
            if (item.children && item.children.length) {
              getIds(item.children);
            } else {
              return;
            }
          });
        };

        getIds(this.columns);
        console.log("zhiClass", zhiClass);
      }

      // console.log("我是zhiClass");
      // console.log(zhiClass);
      // console.log("我是获取到的personType");
      // console.log(JSON.parse(localStorage.getItem("userInfo")).personType);

      const { data, code } = await this.$https.getStudentDataByDeptIdAndDate({
        // deptId: this.classId,
        organizationId: zhiClass,
        personType: 13,
        schoolId: this.$store.state.schoolId,
        toDay: this.date,
      });
      if (code !== 200) {
        this.loading = true;
        return false;
      }
      this.data = data[0];
      this.loading = true;
    },

    prevArrow() {
      this.date = moment(this.date).subtract(1, "days").format("YYYY-MM-DD");
      this.startMinTime = new Date(
        moment(this.date).subtract(1, "days").format("YYYY-MM-DD")
      );
    },
    nextArrow() {
      this.date = moment(this.date).add(1, "days").format("YYYY-MM-DD");
      this.startMinTime = new Date(
        moment(this.date).add(1, "days").format("YYYY-MM-DD")
      );
    },
  },
  components: {
    SelectTime,
  },
  created() {
    this.date = this.$route.query.date;
  },
  watch: {
    date() {
      this.getStudentDataByDeptIdAndDate();
    },
  },
};
</script>

<style lang="scss" scoped>
.dept_select {
  padding-bottom: 15px;
  border-radius: 8px;
  display: flex;
  overflow-y: auto;
  justify-content: space-between;
  .dept_item {
    font-size: 14px;
  }
  .dept_totel {
    flex: 1;
    text-align: right;
    overflow-x: auto;
    font-size: 14px;
  }
}
.wrap {
}
.wrap-1 {
  background: #fff;
  margin: 15px;
  border-radius: 8px;
  margin-bottom: 15px;
}
.class-date {
  padding: 15px 0 0px 0;
  span {
    margin: 0 20px;
    font-size: 15px;
    color: #1a1a1a;
  }
}
.title {
  padding: 12px 25px;
  position: relative;
  font-size: 15px;
  color: #1a1a1a;

  &::before {
    content: "";
    position: absolute;
    left: 15px;
    height: 13px;
    width: 3px;
    background: #37a5da;
    top: 16px;
  }
}
.ss-info {
  .ss-info-content {
    display: inline-block;
  }
  /* display: flex; */
  background: #fff;
  /* box-shadow: 0rem 0rem 1rem rgba(69, 91, 99, 0.08); */
  border-radius: 1rem;
  padding: 1rem 0;
  /* margin-top: 1rem; */
  /* justify-content: center; */
  overflow-x: scroll;
  white-space: nowrap;
  &::-webkit-scrollbar {
    // 直接复制黏贴到样式页.css，完美解决
    display: none;
    /* background-color:transparent; */
  }
  .info-item {
    /* flex: 1; */
    display: inline-block;
    width: 80px;
    text-align: center;
    border-right: 0.06rem solid #f4f4f6;
    /* color: #454f63; */
    color: #666;

    &:last-child {
      border-right: none;
    }
    &.acitve {
      color: #37a5da;
      position: relative;
      &::before {
        content: "";
        height: 2px;
        background: #37a5da;
        width: 30px;
        position: absolute;
        bottom: -13px;
        left: 25px;
      }
    }
    .info-count {
      font-size: 1.25rem;

      /* color: #454f63; */
      .unit {
        font-size: 0.69rem;
        margin-left: 0.4rem;
      }
    }
    .info-name {
      font-size: 0.69rem;
      margin-top: 0.3rem;
    }
  }
}

.list-table {
  background: #fff;
  border-radius: 1rem;
  /* margin-top: 1rem; */
  /* box-shadow: 0rem 0rem 1rem rgba(69, 91, 99, 0.08); */

  .list-table-title {
    font-size: 0.88rem;
    color: #78849e;
    padding: 1rem;
  }
  .list-table-thead {
    display: flex;
    padding: 0 0 1rem 0;
    margin: 0 1rem;
    /* border-top: 0.06rem solid #f4f4f6; */
    border-bottom: 0.06rem solid #f4f4f6;
    align-items: center;
    text-align: center;

    color: #78849e;
    font-size: 0.75rem;
    .table-1 {
      border-right: 0.06rem solid #f4f4f6;
      padding: 0.8rem 0;
    }
    .table-3 {
      border-right: 0.06rem solid #f4f4f6;

      .top {
        margin: 0 0.8rem;

        padding: 0.3rem 0;
        border-bottom: 0.06rem solid #f4f4f6;
      }
      .status {
        padding: 0.3rem 0;
        span {
          flex: 1;
        }
      }
    }
  }
  .list-table-body {
    margin: 0 1rem;
    .list-table-item {
      border-bottom: 0.06rem solid #f4f4f6;
      padding: 1rem 0;
      align-items: center;
      .table-1 {
        color: #454f63;
        font-size: 0.75rem;
        .mark {
          display: inline-block;
          width: 0.63rem;
          height: 0.63rem;
          border-radius: 0.19rem;
          margin-right: 0.3rem;
          &.blue {
            background: #3497fd;
          }
          &.orange {
            background: #ff9057;
          }
          &.red {
            background: #ff5e84;
          }
        }
      }
      .table-3 {
        opacity: 0.98;
        color: #78849e;
        font-size: 0.75rem;
        text-align: center;
        .blue {
          color: #3497fd;
        }
        .orange {
          color: #ff9057;
        }
        .red {
          color: #ff5e84;
        }
      }
    }
  }
}
</style>
